module.exports = __webpack_public_path__ + "static/media/Gado-Gado Indonesian Students Association of UBC (GISAU).b9eb3176.png";